module.exports = __webpack_public_path__ + "static/img/SearchDetailStudy1.75203cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailStudy1.png
// module id = 776
// module chunks = 0